import { PUBLIC_POCKETBASE_URL } from '$env/static/public';
import { handleApiError } from '@astlai/common/util/error-handling';
import type { DocumentDetail, ResourceDetail, ResourcesResponse } from 'src/types/llm';

export class ResourcesClient {
	constructor(private baseURL = PUBLIC_POCKETBASE_URL) {}

	async getDocument(documentId: number): Promise<DocumentDetail> {
		const response = await fetch(this.baseURL + `/proxy/documents/${documentId}`, {
			credentials: 'include'
		});
		await handleApiError(response);
		return response.json();
	}

	async getResource(resourceId: number): Promise<ResourceDetail> {
		const response = await fetch(this.baseURL + `/proxy/resources/${resourceId}`, {
			credentials: 'include'
		});
		await handleApiError(response);
		return response.json();
	}

	async getResources(tenantId: string, page = 1, perPage = 20): Promise<ResourcesResponse> {
		const params = new URLSearchParams({
			page: page.toString(),
			per_page: perPage.toString()
		});
		const response = await fetch(this.baseURL + `/proxy/${tenantId}/resources?${params}`, {
			credentials: 'include'
		});
		await handleApiError(response);
		return response.json();
	}
}

export const resourcesClient = new ResourcesClient();
